"use client";

import { useEffect, useRef, useState } from "react";

/** Run only after navigation, never during a prefetched server render. */
export function ResetRegistrationLogin({ disposable }: { disposable: boolean }) {
  const running = useRef(false);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (running.current) return;
    running.current = true;
    void (async () => {
      try {
        if (disposable) {
          // The existing lifecycle reconciles uncertain submissions and preserves
          // submitted applications before it can archive a disposable draft.
          const response = await fetch("/api/onboarding/registration", {
            method: "POST", credentials: "same-origin", cache: "no-store",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ action: "restart", token: crypto.randomUUID() }),
            signal: AbortSignal.timeout(15_000),
          });
          const result = await response.json();
          if (!response.ok || (result.restart !== true && result.retained !== true)) throw new Error("REGISTRATION_RESET_FAILED");
        }
        // Retained applications and existing accounts only leave this session.
        const response = await fetch("/api/auth/logout", {
          method: "POST", mode: "same-origin", credentials: "same-origin",
          referrerPolicy: "same-origin", cache: "no-store", redirect: "follow",
          signal: AbortSignal.timeout(15_000),
        });
        if (!response.ok || !response.redirected || new URL(response.url).origin !== window.location.origin) throw new Error("LOGOUT_FAILED");
        window.location.reload();
      } catch {
        running.current = false;
        setError("暂时无法打开登录，请重试。");
      }
    })();
  }, [attempt, disposable]);

  return error ? <div role="alert" className="rg-login-form">
    <p className="rg-error">{error}</p>
    <button type="button" className="rg-primary w-full" onClick={() => { setError(""); setAttempt(value => value + 1); }}>重试</button>
  </div> : <div aria-busy="true" className="rg-login-form"><span className="sr-only" role="status">正在打开登录</span></div>;
}
